import moment from "moment";
import { useState } from "react";
import { Camera } from "lucide-react";
import type { AppointmentPhoto, PhotoSide } from "@shyne/shared/api";
import { ImageLightbox } from "@/components/shared/image-lightbox";

const SIDES: { side: PhotoSide; label: string }[] = [
  { side: "before", label: "Before" },
  { side: "after", label: "After" },
];

export function EvidencePhotos({ photos }: { photos: AppointmentPhoto[] }) {
  const [shown, setShown] = useState<{ url: string; alt: string } | null>(null);

  if (photos.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        <Camera className="w-12 h-12 mx-auto mb-4 opacity-50" />
        <p>No photos yet.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {SIDES.map(({ side, label }) => {
        const taken = photos.filter((photo) => photo.side === side);
        if (taken.length === 0) return null;
        return (
          <section key={side} className="space-y-2" aria-label={`${label} photos`}>
            <h3 className="text-sm font-semibold uppercase text-muted-foreground">{label}</h3>
            <div className="flex flex-wrap gap-3">
              {taken.map((photo) => (
                <figure key={photo.id} className="space-y-1">
                  <img
                    src={photo.url}
                    alt={`${label} photo`}
                    className="w-32 h-32 object-cover rounded cursor-pointer hover:opacity-80 transition-opacity"
                    onClick={() => setShown({ url: photo.url, alt: `${label} photo` })}
                  />
                  <figcaption className="text-xs text-muted-foreground">
                    {moment(photo.at).format("MM/DD/YYYY, h:mm a")}
                    {photo.by?.name ? ` · ${photo.by.name}` : ""}
                  </figcaption>
                </figure>
              ))}
            </div>
          </section>
        );
      })}
      <ImageLightbox open={shown !== null} onClose={() => setShown(null)} imageUrl={shown?.url ?? ""} alt={shown?.alt} />
    </div>
  );
}
